import lang from '../lib/language';

type LangKey = keyof typeof lang;

const DEFAULT_REJECT_MESSAGE_KEY: LangKey = 'orderRejectDefault';

export const REJECT_MESSAGE_KEYS: Record<string, LangKey> = {
  'Invalid firm ID': 'orderRejectDefault',
  'Invalid Client ID': 'orderRejectAccountNotRecognized',
  'Missing Client ID': 'orderRejectOrderFailedAccountInfoMissing',
  'Invalid ClOrdID': 'orderRejectOrderCouldntBeSubmitted',
  'Duplicate ClOrdID': 'orderRejectDuplicateOrderDetected',
  'Unknown ClOrdID': 'orderRejectOriginalOrderNotFound',
  'Invalid symbol': 'orderRejectSymbolNotRecognized',
  'No price information for symbol': 'orderRejectNoLivePriceAvailableSymbol',
  'Maximum long/short position exposure equity multiple exceeded': 'orderRejectPositionTooLargeAccount',
  'Maximum long/short position exposure exceeded': 'orderRejectPositionSizeLimitReached',
  'Total position exposure equity multiple exceeded': 'orderRejectTotalHoldingsExceedAccountLimit',
  'Total position exposure exceeded': 'orderRejectTotalPositionLimitReached',
  'Maximum long/short order exposure equity multiple exceeded': 'orderRejectOrderTooLargeAccount',
  'Maximum long/short order exposure exceeded': 'orderRejectOrderSizeLimitReached',
  'Total order exposure equity multiple exceeded': 'orderRejectOpenOrdersExceedAccountLimit',
  'Total order exposure available margin multiple exceeded': 'orderRejectOrderExceedsAvailableMargin',
  'Total order exposure exceeded': 'orderRejectTotalOpenOrdersLimitReached',
  'Maximum long/short combined exposure equity multiple exceeded': 'orderRejectPositionOrderSizeTooLargeAccount',
  'Maximum long/short combined exposure exceeded': 'orderRejectCombinedPositionOrderLimitReached',
  'Total combined exposure equity multiple exceeded': 'orderRejectPositionsOpenOrdersExceedAccountLimit',
  'Total combined exposure exceeded': 'orderRejectPositionsOpenOrdersLimitReached',
  'Maximum equity percentage loss limit reached': 'orderRejectDailyLossLimitReached',
  'Maximum loss limit reached': 'orderRejectMaxLossLimitReached',
  'Maximum equity percentage loss limit per symbol reached': 'orderRejectLossLimitReachedSymbol',
  'Maximum loss limit per symbol reached': 'orderRejectLossLimitReachedSymbol',
  'Maximum equity percentage position value reached': 'orderRejectPositionTooLargeAccount',
  'Maximum position value reached': 'orderRejectPositionValueLimitReached',
  'Buying power equity multiple exceeded': 'orderRejectNotEnoughBuyingPower',
  'Buying power dollar amount exceeded': 'orderRejectNotEnoughBuyingPower',
  'Maximum position size reached': 'orderRejectPositionSizeLimitReached',
  'Maximum number of positions reached': 'orderRejectPositionLimitReached',
  'Maximum net position imbalance reached': 'orderRejectPositionLimitReached',
  'Maximum permissible order size exceeded': 'orderRejectOrderSizeTooLarge',
  'Maximum permissible order value exceeded': 'orderRejectOrderValueTooLarge',
  'Order is priced significantly away from the market': 'orderRejectPriceTooFarFromMarket',
  'Order is priced below the minimum share/contract price': 'orderRejectPriceBelowMinimumAllowed',
  'Maximum share/contract price exceeded': 'orderRejectPriceAboveMaximumAllowed',
  'Odd lots are not allowed': 'orderRejectOddLotSizesNotAllowed',
  'Symbol buying power exceeded': 'orderRejectInsufficientBuyingPowerSymbol',
  'Symbol maximum quantity exceeded': 'orderRejectQuantityLimitReachedSymbol',
  'Symbol is restricted for short sales': 'orderRejectShortSellingRestrictedSymbol',
  'Symbol is restricted': 'orderRejectSymbolRestricted',
  'Short sales are not allowed': 'orderRejectShortSellingNotAllowedAccount',
  'Account or session is in no order entry mode': 'orderRejectTradingCurrentlyDisabled',
  'Account is in no short sell order entry mode': 'orderRejectShortSellingDisabledAccount',
  'Account is in closeout mode': 'orderRejectAccountRestrictedClosingPositionsOnly',
  'Account or session has been disabled': 'orderRejectAccountOrSessionDisabled',
  'Sell short order is mismarked as sell': 'orderRejectOrderTypeMismatchSellShort',
  'Symbol is not easy to borrow and has no locate': 'orderRejectNoSharesAvailableBorrowShort',
  'Market order quantity exceeds allowed ADV percentage': 'orderRejectOrderTooLargeTradingVolume',
  'No entitlement for symbol': 'orderRejectYoureNotEntitledTradeSymbol',
  'Sell order is mismarked as sell short': 'orderRejectOrderTypeMismatchSellShort',
  'Duplicative order': 'orderRejectDuplicateOrderNotPlaced',
  'Unsupported request type': 'orderRejectOrderTypeIsntSupported',
  'Invalid Order Capacity': 'orderRejectOrderDetailsInvalid',
  'Ticket already closed': 'orderRejectOrderAlreadyClosed',
  'Order is already pending replace': 'orderRejectOrderChangeAlreadyInProgress',
  'Market orders are not allowed': 'orderRejectMarketOrdersArentAllowed',
  'Short exempt orders are not allowed': 'orderRejectShortExemptOrdersNotAllowed',
  'MOO orders are not allowed': 'orderRejectMarketOpenOrdersNotAllowed',
  'LOO orders are not allowed': 'orderRejectLimitOpenOrdersNotAllowed',
  'IOO orders are not allowed': 'orderRejectOrderTypeIsntAllowed',
  'IOC orders are not allowed': 'orderRejectImmediateOrCancelOrdersNotAllowed',
  'GTC orders are not allowed': 'orderRejectGoodTillCancelledOrdersNotAllowed',
  'GTD orders are not allowed': 'orderRejectGoodTillDateOrdersNotAllowed',
  'ISO orders are not allowed': 'orderRejectOrderTypeIsntAllowed',
  'MOC orders are not allowed due to regulatory restriction': 'orderRejectMarketCloseBlockedRegulatory',
  'MOC orders are not allowed': 'orderRejectMarketCloseOrdersNotAllowed',
  'LOC orders are not allowed due to regulatory restriction': 'orderRejectLimitCloseBlockedRegulatory',
  'LOC orders are not allowed': 'orderRejectLimitCloseOrdersNotAllowed',
  'Wash sale prevention': 'orderRejectOrderBlockedPossibleWashSale',
  'ADV for this security is below specified minimum': 'orderRejectTradingVolumeTooLowOrder',
  'Cumulative order quantity exceeds allowed ADV percentage': 'orderRejectOrdersTooLargeDailyVolume',
  'Traded volume exceeds allowed ADV percentage': 'orderRejectTradesTooLargeDailyVolume',
  'Maximum allowed number of bid/ask price levels reached': 'orderRejectTooManyActivePriceLevels',
  'Maximum allowed number of bid/ask price levels per destination reached': 'orderRejectTooManyPriceLevelsAtExchange',
  'Maximum allowed number of bid or offers reached': 'orderRejectTooManyOpenOrdersActive',
  'Maximum allowed number of bid or offers per destination reached': 'orderRejectTooManyOpenOrdersAtExchange',
  'Minimum order cancellation time is in force': 'orderRejectPleaseWaitBeforeCancellingOrder',
  'Invalid HandlInst': 'orderRejectOrderDetailsInvalid',
  'Price collar violation': 'orderRejectPriceOutsideAllowedRange',
  'Maximum permissible MOC order quantity exceeded': 'orderRejectMocOrderQuantityTooLarge',
  'Maximum permissible MOC order value exceeded': 'orderRejectMocOrderValueTooLarge',
  'Odd lot allowance exceeded': 'orderRejectOddLotOrderLimitReached',
  'Regulatory restriction': 'orderRejectBlockedDueRegulatoryRestriction',
};

const normalizeRejectReason = (reason: string) => reason.trim().replace(/\s+/g, ' ').replace(/\.$/, '').toLowerCase();

const REJECT_MESSAGE_KEYS_BY_REASON = new Map<string, LangKey>(
  Object.entries(REJECT_MESSAGE_KEYS).map(([reason, key]) => [normalizeRejectReason(reason), key]),
);

export const getOrderRejectMessage = (rejectReason?: unknown): string => {
  const key = typeof rejectReason === 'string'
    ? REJECT_MESSAGE_KEYS_BY_REASON.get(normalizeRejectReason(rejectReason))
    : undefined;

  return lang[key ?? DEFAULT_REJECT_MESSAGE_KEY]();
};
